import React, { useEffect, useState } from "react";
import { X, Megaphone, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Site-wide notice published by Owner/Admin. One quiet line, dismissible per member per announcement.
export function AnnouncementBar({ className = "" }) {
  const { user } = useAuth();
  const [a, setA] = useState(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => { api.announcement().then(setA).catch(() => setA(null)); }, []);
  if (!a || hidden) return null;
  const key = `ann_dismissed:${user?.user_id}:${a.id}`;
  try { if (localStorage.getItem(key)) return null; } catch {}
  const dismiss = () => { setHidden(true); try { localStorage.setItem(key, "1"); } catch {} };
  return (
    <div data-testid="announcement-bar" className={`mx-auto mb-3 flex max-w-[600px] items-center gap-3 rounded-2xl border border-am-border-strong bg-am-surface px-4 py-2.5 text-sm ${className}`}>
      <Megaphone className="h-4 w-4 shrink-0 text-aura-cyan" />
      <div className="min-w-0 flex-1"><span className="font-bold text-white">{a.title}</span>{a.body && <span className="text-am-text2"> — {a.body}</span>}{a.link && <a href={a.link} target="_blank" rel="noopener noreferrer" data-testid="announcement-link" className="ml-2 inline-flex items-center gap-1 text-aura-cyan hover:underline">Open <ExternalLink className="h-3 w-3" /></a>}</div>
      <button onClick={dismiss} aria-label="Dismiss announcement" data-testid="announcement-dismiss" className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-am-text2 hover:bg-white/10 hover:text-white"><X className="h-4 w-4" /></button>
    </div>
  );
}
